var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { omit } from '@showroomjs/core';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '../lib/routing';
import { THEME } from '../theme';
const SITE_URL = process.env.SITE_URL;
const BASE_PATH = process.env.BASE_PATH;
export const Seo = (props) => {
    return (React.createElement(Head, Object.assign({ defaultTitle: THEME.title, titleTemplate: `%s | ${THEME.title}` }, props)));
};
export const Head = (_a) => {
    var { description, children } = _a, props = __rest(_a, ["description", "children"]);
    const { pathname } = useLocation();
    const isHomepage = pathname === '/';
    const realUrl = SITE_URL && `${SITE_URL}${BASE_PATH}${pathname === '/' ? '' : pathname}`;
    return (React.createElement(Helmet, Object.assign({}, (isHomepage ? omit(props, ['title']) : props)),
        realUrl && React.createElement("link", { rel: "canonical", href: realUrl }),
        props.title && React.createElement("meta", { name: "twitter:title", content: props.title }),
        React.createElement("meta", { name: "twitter:card", content: "summary" }),
        description && React.createElement("meta", { name: "description", content: description }),
        description && (React.createElement("meta", { name: "twitter:description", content: description })),
        React.createElement("meta", { property: "og:type", content: "article" }),
        realUrl && React.createElement("meta", { property: "og:url", content: realUrl }),
        props.title && React.createElement("meta", { property: "og:title", content: props.title }),
        description && React.createElement("meta", { property: "og:description", content: description }),
        children));
};
//# sourceMappingURL=seo.js.map